import React, { FC, useState } from 'react';
import { Button, Tooltip } from 'antd';
import styled from 'styled-components';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { RegularText } from '../../utils/typography';
import { getErrorMessage } from '../../api/network';

type Props = {
  title?: string;
  Icon?: any;
  action: Function;
  doneText: string;
  onSuccess?: Function;
  onError?: Function;
  disabled?: boolean;
  tooltip?: string;
};

const SafeAction: FC<Props> = ({ title, Icon, action, doneText, onSuccess, onError, tooltip, disabled = false }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [executed, setExecuted] = useState(false);

  if (executed) {
    return <RegularText>{doneText}</RegularText>;
  }

  if (showConfirmation) {
    return (
      <ConfirmationContainer>
        <Button
          type="link"
          icon={<CheckOutlined />}
          onClick={async () => {
            const result = await action();
            if (result.ok) {
              setExecuted(true);
              if (onSuccess) {
                onSuccess(result.data);
              }
            } else {
              if (onError) {
                onError(getErrorMessage(result));
              }
            }
          }}
        />
        <Button type="link" icon={<CloseOutlined />} onClick={() => setShowConfirmation(false)} />
      </ConfirmationContainer>
    );
  }

  if (title) {
    return tooltip ? (
      <Tooltip title={tooltip}>
        <Button type="link" onClick={() => setShowConfirmation(true)} disabled={disabled}>
          {title}
        </Button>
      </Tooltip>
    ) : (
      <Button type="link" onClick={() => setShowConfirmation(true)} disabled={disabled}>
        {title}
      </Button>
    );
  }

  return tooltip ? (
    <Tooltip title={tooltip}>
      <Button type="link" onClick={() => setShowConfirmation(true)} icon={Icon} disabled={disabled} />
    </Tooltip>
  ) : (
    <Button type="link" onClick={() => setShowConfirmation(true)} icon={Icon} disabled={disabled} />
  );
};

export default SafeAction;

const ConfirmationContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
